import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { t } from 'Src/i18n';

type Props = {
  className?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
};

export const FiltersBarClearAllBtn = ({ className, onClick }: Props) => (
  <button
    className={classnames('text-12 text-black underline md:text-14 lg:text-16', className)}
    data-testid="removeAllFilters"
    onClick={onClick}
    type="button"
  >
    {t('filters.removeAll')}
  </button>
);
